const STEPS = [
  {
    step: "Step 1",
    title: "Book a time on our calendar",
    text: "Pick a day and time that suits you — no phone tag, no waiting for a call back. Coordinators can book on behalf of participants too.",
  },
  {
    step: "Step 2",
    title: "We call to confirm",
    text: "A real person from our local team rings you to confirm the details, answer questions and understand what you need.",
  },
  {
    step: "Step 3",
    title: "Support begins",
    text: "We meet, get to know you, and put a service agreement in place. Supports start as soon as the agreement is approved.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-20 px-5 sm:px-8 bg-[#F6F1EA] border-t border-[#EAE3D8]" data-testid="how-it-works-section">
      <div className="max-w-6xl mx-auto space-y-12">
        <div className="text-center max-w-2xl mx-auto space-y-3">
          <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Getting Started</span>
          <h2 className="text-3xl sm:text-4xl font-display font-medium text-[#1E282D]">From first booking to first visit, in three steps</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <div key={s.step} className="relative p-7 rounded-2xl bg-[#FAF8F5] border border-[#E4DCCE] space-y-3 reveal" style={{ animationDelay: `${i * 0.1}s` }}>
              <div className="text-xs font-semibold uppercase tracking-wider text-[#736353]">{s.step}</div>
              <h3 className="text-xl font-display font-medium text-[#1E282D]">{s.title}</h3>
              <p className="text-sm text-[#4E5B62] leading-relaxed">{s.text}</p>
            </div>
          ))}
        </div>
        <div className="text-center">
          <a href="#contact" data-testid="how-it-works-book-button" className="inline-flex px-7 py-3.5 rounded-full text-base font-medium text-[#FAF8F5] bg-[#223036] hover:bg-[#141E22] transition-colors shadow-sm">
            Start with Step 1 — Book a Time
          </a>
        </div>
      </div>
    </section>
  );
}
